import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useHelp } from '../context/HelpContext';

const HelpIcon = ({ helpKey }) => {
  const { showHelp } = useHelp();

  return (
    <IconButton onClick={() => showHelp(helpKey)} size="small">
      <HelpOutlineIcon />
    </IconButton>
  );
};

HelpIcon.propTypes = {
  helpKey: PropTypes.string.isRequired,
};

export default HelpIcon;
